import React from 'react';

import './terms-and-conditions.scss';

import TermsAndConditionsFunctional from './components/terms-and-conditions-functional';

const TermsAndCondition = ({ history, fromDashboard = false }) => {
	return <TermsAndConditionsFunctional history={history} fromDashboard={fromDashboard} />;
};

export default TermsAndCondition;
